import React, {useEffect} from 'react';
import { MuiFileInput } from 'mui-file-input';
import LinearProgress from '@mui/material/LinearProgress';
// Removed unused useStyles

const FileUpload = ({type,
  id,
  required,
  error,
  label,
  disabled,
  maxSize,
  tooltiptext,
  defaultValue,
  acceptedFiles,
  action,
  multiUpload,
  onUpload
}) => {
  const [loading, setLoading] = React.useState(false);
  const [fileObjects, setFileObjects] = React.useState([]);
  const [tooltipData, setTooltipData] = React.useState([]);

  useEffect(() => {
    const tooltip = document.getElementById(`uploadTootip_${id}`)
    setTooltipData(tooltip)
    if(tooltipData) tooltipData.innerHTML = tooltiptext;

  }, [tooltipData])

  // Removed unused onDelete function
  // Removed unused classes variable

  return (
    <div data-testid='fileUpload' className={disabled ? 'fileUpload dropzoneDisabled' : 'fileUpload'}>
      {loading && <LinearProgress />}

      <div>
        <se-form-field
            label={label}
            type={type}
            block
            required={required}
            disabled={disabled}
            status={error ? 'error' : null}
            label-align='left'
        >
            <div className='with-icon searchdiv'>
                <input 
                className='fileNameBox'
                type={type}
                disabled
                readOnly
                placeholder={fileObjects.length > 0 && fileObjects[0].file.name ? fileObjects[0].file.name : defaultValue ? defaultValue : 'Select File'}
                />
                {!disabled && <se-tooltip position='top'>
                  <se-icon style={{cursor: 'pointer'}} slot='trigger' option='raised' size='small' className='searchicon'>
                  {action}
                  </se-icon>
                  <div id={`uploadTootip_${id}`}></div>
                </se-tooltip>}
            </div>

            {!disabled && <MuiFileInput
              value={fileObjects[0]?.file || null}
              onChange={(file) => {
                if (file) {
                  const newFiles = [{ file }];
                  setFileObjects(newFiles);
                  setLoading(true);
                  setTimeout(() => {
                    setLoading(false);
                    if (onUpload) onUpload(newFiles);
                  }, 2000);
                } else {
                  setFileObjects([]);
                  if (onUpload) onUpload([]);
                }
              }}
              inputProps={{
                accept: acceptedFiles?.join(',') || undefined,
                multiple: !!multiUpload,
                maxSize: maxSize || 1e+7
              }}
              placeholder={defaultValue || 'Select File'}
              disabled={disabled}
            />}
        </se-form-field>
      </div>
    </div>
  );
};
export default FileUpload;